import * as Types from 'constants/ActionTypes';

const chart = (state = {
    inProgress: false,
    didInvalidate: false,
    data: {},
}, action) => {
    switch (action.type) {
        case Types.FETCH_MEASURES_DATA:
            return Object.assign({}, state, {
                inProgress: true,
                didInvalidate: false
            })
        case Types.FETCH_MEASURES_DATA_SUCCESS:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                data: action.payload,
                lastUpdated: action.receivedAt
            })
        case Types.FETCH_MEASURES_DATA_FAILURE:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                lastUpdated: action.receivedAt
            })
        default:
            return state
    }
};

export default chart